import _uniqBy from 'lodash/uniqBy';
import { t } from 'src/i18n';
import actions from './actions';
import { createReducer, getError } from '../../../../helpers/reducer';
import { keyBy } from '../../../../helpers/core';

function setInitialFormData(name, value) {
  return {
    name,
    value,
    error: '',
    touched: false,
  };
}

const initState = {
  loading: false,
  requestedSectorId: null,
  requestedPositionId: null,
  suggestedSectorId: null,
  suggestedPositionId: null,
  requestedChecks: [],
  suggestedChecks: [],
  requestedSectors: [],
  requestedPositions: [],
  suggestedSectors: [],
  suggestedPositions: [],
  editForm: {
    expiry: setInitialFormData('expiry', ''),
    document_image: setInitialFormData('document_image', ''),
  },
  isBackgroundCheckModalVisible: false,
};

function validate(/* attr, value */) {
  return '';
}

function getOptions(checks, key) {
  const options = [];
  checks.map(check => options.push(...check[key]));

  return [
    { id: null, name: t('dash.common.any') },
    ..._uniqBy(options, 'id').sort((a, b) => a.name.localeCompare(b.name)),
  ];
}

function formatChecks(checks) {
  return checks.map(check => {
    return { ...check, children: check.children && check.children.length ? check.children : undefined };
  });
}

function onLoad(state) {
  return { ...state, loading: true };
}

function onCreateBackgroundCheck(state) {
  return { ...state, loading: true };
}

function onCreateBackgroundCheckError(state) {
  return { ...state, loading: false };
}

function onReorderBackgroundCheck(state) {
  return { ...state, loading: true };
}

function onReorderBackgroundCheckError(state) {
  return { ...state, loading: false };
}

function onLoadSuccess(state, { payload }) {
  const { requestedChecks, suggestedChecks } = payload;

  const requestedChecksIds = requestedChecks.map(item => item.id);
  const filteredSuggestedChecks = suggestedChecks.filter(check => !requestedChecksIds.includes(check.id));

  return {
    ...state,
    requestedChecks: formatChecks(requestedChecks),
    suggestedChecks: formatChecks(filteredSuggestedChecks),
    requestedSectors: getOptions(requestedChecks, 'sector'),
    requestedPositions: getOptions(requestedChecks, 'position'),
    suggestedSectors: getOptions(filteredSuggestedChecks, 'sector'),
    suggestedPositions: getOptions(filteredSuggestedChecks, 'position'),
    loading: false,
  };
}

function onChangeProperty(state, { payload }) {
  return {
    ...state,
    [payload.key]: payload.value,
  };
}

function onChangeEditFormProperty(state, { payload }) {
  const { attr, value } = payload;

  const { editForm } = state;

  editForm[attr] = {
    value,
    error: validate(attr, value),
    name: attr,
    touched: true,
  };

  return {
    ...state,
    editForm: {
      ...editForm,
    },
  };
}

function onClearStore() {
  return {
    ...initState,
  };
}

function onClearModal(state) {
  return {
    ...state,
    editForm: {
      expiry: setInitialFormData('expiry', ''),
      document_image: setInitialFormData('document_image', ''),
    },
    isBackgroundCheckModalVisible: false,
  };
}

function onToggleBackgroundCheckModal(state) {
  return {
    ...state,
    isBackgroundCheckModalVisible: !state.isBackgroundCheckModalVisible,
  };
}

function onSaveError(state, { payload }) {
  const { data } = payload;

  const propsArray = Object.entries(state.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [prop, value] = entry;

      return prop === 'positions'
        ? value
        : {
            ...value,
            error: getError(entry[0], data),
            touched: true,
          };
    },
  );

  return {
    ...state,
    editForm,
  };
}

export default createReducer(initState, {
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.CHANGE_EDIT_FORM_PROPERTY]: onChangeEditFormProperty,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.CREATE_BACKGROUND_CHECK]: onCreateBackgroundCheck,
  [actions.CREATE_BACKGROUND_CHECK_ERROR]: onCreateBackgroundCheckError,
  [actions.REORDER_BACKGROUND_CHECK]: onReorderBackgroundCheck,
  [actions.REORDER_BACKGROUND_CHECK_ERROR]: onReorderBackgroundCheckError,
  [actions.LOAD_REQUEST]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_MODAL]: onClearModal,
  [actions.TOGGLE_BACKGROUND_CHECKS_MODAL]: onToggleBackgroundCheckModal,
  [actions.SAVE_ERROR]: onSaveError,
});
